<template>
  <v-layout class="position-relative forgot-password">
    <nuxt-link v-if="!isSubmit" to="/login" class="d-flex primary--text btn-back">
      <v-icon size="28" color="primary" class="mr-2">
        keyboard_backspace
      </v-icon>
      <span class="my-auto text-button">Sign In</span>
    </nuxt-link>

    <v-layout column class="mx-auto px-15 wrap-content">
      <template v-if="isSubmit">
        <img
          src="~/assets/images/sent-email.jpg"
          width="120"
          height="120"
          class="mx-auto"
        >
        <p class="my-11 text-body-1">
          <v-icon size="20" color="#56BE8C" class="mr-1">
            mdi-check-circle
          </v-icon>
          A reset link was sent to your email address. Please click on the link in the email to change your password.
        </p>
        <div class="text-center">
          <v-btn
            x-large
            depressed
            to="/login"
            color="primary"
          >
            Back to Sign In
          </v-btn>
        </div>
      </template>
      <template v-else>
        <h5 class="mb-7 text-center text-h5">
          Forgot Password
        </h5>

        <p class="mb-4 text-body-1 text-center">
          Enter your recovery email.
        </p>

        <v-form ref="form" @submit.prevent="submit">
          <label class="text-subtitle-1">Email</label>
          <v-text-field
            v-model="formData.email"
            :rules="[$formRules.required, $formRules.email]"
            dense
            outlined
            placeholder="Enter your email"
            class="mt-2"
          />

          <v-btn
            x-large
            depressed
            type="submit"
            width="100%"
            class="mt-4 primary"
          >
            Reset Password
          </v-btn>
        </v-form>
      </template>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'ForgotPassword',

  layout: 'authentication',

  auth: false,

  data: () => ({
    isSubmit: false,
    formData: {}
  }),

  methods: {
    async submit() {
      const ok = this.$refs.form.validate()
      if (!ok) { return }
      try {
        const data = await this.$axios.$post('/auth/forgot-password', this.formData)
        if (data.ok) {
          this.isSubmit = true
        }
      } catch (error) {
        this.$notify.error({
          title: 'Forgot Password',
          message: this.$helpers.apiErrorMessage(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.forgot-password {
  padding-top: 160px;
  .btn-back {
    position: absolute;
    left: 40px;
    top: 30px;
  }
  .wrap-content {
    max-width: 570px;
  }
}
</style>
